export const PAYMASH_ENV = {
  enabledConsoleOutput: false
};
